



import controller from './account.controller';
import templateBase from './templates/account-base.view.html';
import templateAD from './templates/account-adaptative.html';

let AccountComponent = {
  template: changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');

  if(__env.adaptative) {
      return templateAD;
  } else {
      return templateBase;
  }


}

export default AccountComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/account/account.component.js
 **/